var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-card" },
    [
      _c("snt-printer", {
        attrs: {
          items: _vm.canvas,
          callback: _vm.callbackPrinter,
          "aspect-ratio": _vm.aspectRatio,
          width: _vm.width,
          height: _vm.height,
          "inner-width": _vm.innerWidth,
          "inner-height": _vm.innerHeight,
          margin: _vm.margin,
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "template-card__header d-flex ma-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "mr-1" },
                      [
                        _c("RemovePaper", {
                          attrs: { "item-id": _vm.itemId },
                          on: {
                            submitted: function ($event) {
                              return _vm.$emit("removed")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "mr-1" },
                      [
                        _c("CopyPaper", {
                          staticClass: "ml-1",
                          attrs: { "item-id": _vm.itemId },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          to: `/document/edit/${_vm.itemId}`,
                          color: "primary",
                          small: "",
                          depressed: "",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("app.btn.edit")) + " ")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }